import { Button, DatePicker, message, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "@/components/table/Auth";
import imgSave from "@/components/table/saveImg";
import dataDefault from './data';
import { columns, compute } from "./compute";
import request from "@/method/axios";
import _ from 'lodash';

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().isBefore(moment('2023-12-31')) ? '2024-01' : moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        data4_1: [],
        elseData: {},
        key: "_4_2_1_new"
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data, elseData) => {
        data = compute(data, elseData);
        this.setState({ data, loading: false, });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data, this.state.elseData);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true });
            let data = JSON.parse(JSON.stringify(dataDefault));
            let month = moment(date).format('M');
            const year = moment(date).format('YYYY');
            const res = await request.post('/api/data', {
                list: [{
                    name: "data",
                    key: this.state.key, year, month
                }, {
                    name: "budget",
                    key: "_4new_4_3_1_budget", year,
                }, {
                    name: "actual",
                    key: "_4new_4_3_1_forecast", year, month
                }, {
                    name: "forecast",
                    key: '_4new_4_3_1_forecast', year: moment(date).subtract(1, 'month').format('YYYY'), month: moment(date).subtract(1, 'month').format('M')
                }, {
                    name: "last",
                    key: year > 2024 ? "_4new_4_3_1_forecast" : '_4_1_rev',
                    year: ~~(year - 1), month
                }]
            });
            if (res.data.data && res.data.data.length) data = res.data.data;
            this.computeNum(data, { ...res.data, month, year });
            this.setState({ elseData: { ...res.data, month, year } })
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    onSave = async () => {
        try {
            let { date, key } = this.state;
            if (!date) return message.error('请选择年份月份');

            this.setState({ loadingSave: true });
            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let data = this.state.data.map((x, i) => {
                const res = ({ ...x, year, sort: i, month })
                return res;
            });
            const postData = {
                data,
                year,
                key,
                month
            };
            const x = await request.post(`/api/save`, postData);
            this.setState({ loadingSave: false });
            if (x.code == 200) {
                message.success("保存成功！");
                if (!data[0].id) this.getData(this.state.date);
                this.props.update();
            }
        } catch (err) {
            this.setState({ loadingSave: false });
            console.error(err);
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4', 1.5, '4.21', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} 4.2.1 Monthly Market Segment Report 月度市场细分表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading, key } = this.state;

        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4" style={{ width: print ? 6150 : 'auto' }} >
                    <Row>4.2.1 Monthly Market Segment Report 月度市场细分表</Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            disabledDate={v => {
                                if (moment(v).isAfter(moment('2023-12-31'))) return false;
                                return true;
                            }}
                            value={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str);
                            }}
                        />
                    </Row>
                    <Table
                        columns={columns(this.onChange, date, print)}
                        dataSource={data}
                        size="middle"
                        id="table4_1_4"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"

                        scroll={print ? {} : { x: true, y: 500 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_4_2_1_new">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.1/forecast.js